import React from "react";
import { useState, useEffect } from "react";
import { BrowserRouter, useNavigate, Routes, Route } from "react-router-dom";
import logo from "../images/logo-dark.png";
import { useDispatch, useSelector } from "react-redux";
import { userLogin } from "../action/UserAction";

export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userInfo, exdt, success, loading, error } = useSelector(
    (s) => s.loginUsers
  );

  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const handlelogin = (e) => {
    e.preventDefault();
    dispatch(
      userLogin({
        Username: email,
        Password: pwd,
      })
    );
  };

  useEffect(() => {
    if (success) {
      window.location.reload();
      setEmail("");
      setPwd("");
    }
    if (userInfo) {
      let dttt = new Date().getTime() - parseInt(exdt);
      if (parseInt(dttt) < 36000000) {
        window.location.href = "/lead-marketing";
      }
    }
  }, [dispatch, success]);

  return (
    <>
      <div className="container d-flex align-items-center justify-content-center vh-100">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-10">
            <div className="card">
              <div className="card-body p-5">
                <div>
                  {/*<h4 className="text-dark mb-5">Sign In</h4>*/}
                  <img
                    src={logo}
                    width="50%"
                    style={{
                      textAlign: "center",
                      paddingBottom: "10px",
                      margin: "auto",
                    }}
                  />
                </div>
                <form onSubmit={handlelogin}>
                  <div className="row">
                    <div className="form-group col-md-12 mb-4">
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="form-control input-lg"
                        placeholder="Username"
                      />
                    </div>
                    <div className="form-group col-md-12 ">
                      <input
                        type="password"
                        value={pwd}
                        onChange={(e) => setPwd(e.target.value)}
                        className="form-control input-lg"
                        placeholder="Password"
                      />
                    </div>
                    <br /> <br /> <br />
                    <button
                      type="submit"
                      onClick={handlelogin}
                      className="btn btn-lg btn-primary btn-block mb-4"
                    >
                      Sign In
                    </button>
                    {error ? <span style={{ color: "red" }}>{error}</span> : ""}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
